import { render, staticRenderFns } from "./EPMEvaluationBibliographicResource.vue?vue&type=template&id=55b8ea24&scoped=true"
import script from "./EPMEvaluationBibliographicResource.vue?vue&type=script&lang=js"
export * from "./EPMEvaluationBibliographicResource.vue?vue&type=script&lang=js"
import style0 from "@/utils/rich_text_editor.css?vue&type=style&index=0&id=55b8ea24&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b8ea24",
  null
  
)

export default component.exports